let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("jvSpc")), load("8tT3q")]).then(() => parcelRequire('azPLx'));